import {Component, Input} from '@angular/core';
import {PostModel} from "../../models/post.model";
import {IonicModule} from "@ionic/angular";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-action-point-metric-component',
  templateUrl: './action-point-metric-component.component.html',
  styleUrls: ['./action-point-metric-component.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    TranslatePipe,
  ]
})
export class ActionPointMetricComponentComponent {
  @Input() actionPoint: PostModel = null;
}
